module.exports = __webpack_public_path__ + "img/lv14.da412277.png";